@if (toast) {
<tds-toast
  variant="{{ toast.state }}"
  header="{{ toast.title }}"
  subheader="{{ toast.message }}"
  closable="false"
></tds-toast>
}
